import {EquipmentOption} from '../types'

export const createEquipmentOptionKey = (equipmentOption: EquipmentOption) =>
  `${equipmentOption.type}:${equipmentOption.id}`

export const mapEquipmentOptions = (equipmentOptions: EquipmentOption[]) =>
  equipmentOptions.map((equipmentOption) => ({
    value: createEquipmentOptionKey(equipmentOption),
    label: equipmentOption.label
  }))

export const isEmptySelectedValue = (
  value: string | number | null | undefined
): value is null | undefined =>
  value === null || value === undefined || value === '' || Number.isNaN(value)

export const mapSelectedValue = (
  value: string | number | null | undefined
): (string | number)[] => {
  if (isEmptySelectedValue(value)) {
    return []
  }

  return [value]
}
